import DOMPurify from "dompurify";

/**
 * xss
 */
export function filterXSS(input: string) {
    return DOMPurify.sanitize(input, {
        USE_PROFILES: { html: true },
        ADD_ATTR: ['fixed', 'target', 'rel', 'data-id'],
    });
}

export function filterXSSRichHtml(input: string) {
    return DOMPurify.sanitize(input, {
        USE_PROFILES: {html: true},
        ADD_TAGS: ['iframe'],
        ADD_ATTR: ['fixed', 'target', 'rel', 'allow', 'allowfullscreen', 'frameborder', 'data-metafield', 'data-id', 'data-label', 'data-original', 'data-status', 'data-status-label', 'data-widget'],
    });
}